import React, { useEffect, useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { api, urls } from "../../../api/api";

export default function NotificationDropdown() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try {
      const r = await api.get(urls.uiNotifications);
      setUnread(r.data?.unread || 0);
      setItems(Array.isArray(r.data?.items) ? r.data.items : []);
    } catch {
      // silent
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);

  const markRead = async (id) => {
    try {
      await api.post(urls.uiNotifRead(id));
      await load();
    } catch {}
  };

  const markAll = async () => {
    try {
      await api.post(urls.uiNotifReadAll);
      await load();
    } catch {}
  };

  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)} className="d-inline-block">
      <DropdownToggle className="btn header-item noti-icon" tag="button" id="page-header-notifications-dropdown">
        <i className="mdi mdi-bell-outline" />

        {unread > 0 && (
          <Badge color="danger" pill className="badge rounded-pill">
            {unread}
          </Badge>
        )}
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu dropdown-menu-end p-0" style={{ width: 360 }}>
        <div className="p-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h6 className="m-0">Notifications ({unread})</h6>
              <div className="text-muted" style={{ fontSize: 12 }}>Unread: {unread}</div>
            </div>
            <button className="btn btn-sm btn-light" onClick={markAll} title="Mark all as read">
            ✓
            </button>

          </div>
        </div>

        <div style={{ maxHeight: 320, overflowY: "auto" }}>
          {items.length === 0 ? (
            <div className="p-3 text-muted">Aucune notification</div>
          ) : (
            items.map((n) => (
              <DropdownItem key={n.id} className="py-2" onClick={() => markRead(n.id)}>
                <div className="d-flex gap-2">
                  <div style={{ width: 10, marginTop: 6 }}>
                    {n.status === "unread" ? <span className="badge bg-warning"> </span> : null}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="fw-semibold">{n.title}</div>
                    <div className="text-muted" style={{ fontSize: 13 }}>{n.body}</div>
                    <div className="mt-1">
                      <Link to={n.action_url || "/reservations"} className="text-decoration-underline">
                        Go to calendar →
                      </Link>
                    </div>
                  </div>
                  <div>
                    <Badge color="warning" pill>pending</Badge>
                  </div>
                </div>
              </DropdownItem>
            ))
          )}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
}
